import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const Input = styled.input`
    width: 100%;
    height: 44px;
    padding: 0 14px;
    border: 1px solid ${colors.fieldBorder};
    border-radius: ${radii.base};
    background: ${colors.surface};
    font-family: inherit;
    font-size: 15px;
    letter-spacing: 0.02em;
    color: ${colors.textPrimary};
    outline: none;

    &:focus {
        border-color: ${colors.primary};
    }

    &::placeholder {
        color: ${colors.textSecondary};
        letter-spacing: normal;
    }

    &:disabled {
        opacity: 0.6;
    }
`;
